export function getCurrentPosition(enableHighAccuracy = true) {
  if ('geolocation' in navigator) {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy,
        maximumAge: 10000,
        timeout: 10000
      })
    })
  } else {
    console.error('Geolocation not in navigator')

    throw new Error('Geolocation is not supported on your device')
  }
}
